
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carts",
      function () {
        return require("private-next-pages/carts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carts"])
      });
    }
  